import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appAlphanumericOnly]'
})
export class AlphanumericOnlyDirective {
  private readonly alphanumericRegex = /^[a-zA-Z0-9]$/;

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    if (!this.alphanumericRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    if (!/^[a-zA-Z0-9]*$/.test(clipboardData)) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    const droppedData = event.dataTransfer?.getData('text') ?? '';
    if (!/^[a-zA-Z0-9]*$/.test(droppedData)) {
      event.preventDefault();
    }
  }
}
